import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  // public url = 'http://localhost:36027/api/';
  // public imagepath = 'http://localhost:36027/PromoterDocs/';
  public imagepath = 'http://103.172.151.44:3002/PromoterDocs/';
  public Customerimagepath = 'http://103.172.151.44:3002/CustomerDocs/';
  public url = 'http://103.172.151.44:3002/api/';

  constructor(private api: HttpClient) { }

  

  get(endpoint: string, params?: any, reqOpts?: any): Observable<any> {
    return this.api.get(this.url + endpoint, reqOpts);
  }

  post(endpoint: string, body: any, reqOpts?: any): Observable<any> {
    return this.api.post(this.url + endpoint, body, reqOpts);
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    return this.api.put(this.url + endpoint, body, reqOpts);
  }
  delete(endpoint: string, reqOpts?: any) {
    return this.api.delete(this.url + endpoint, reqOpts);
  }
  patch(endpoint: string, body: any, reqOpts?: any) {
    return this.api.put(this.url + endpoint, body, reqOpts);
  }


}

